import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, asset } from "../api";
import { Layout } from "../components/Layout";
import { useReveal } from "../useReveal";

export default function Projeler() {
  const [sekme, setSekme] = useState("hepsi");
  const { data: projects = [], isLoading } = useQuery({
    queryKey: ["projects"], queryFn: async () => (await api.get("/projects")).data,
  });
  useReveal(!isLoading);
  const filtreli = projects.filter((p) =>
    sekme === "hepsi" ? true : sekme === "devam" ? p.status === "devam-eden" : p.status === "tamamlandi"
  );
  const sekmeler = [
    { k: "hepsi", l: "Hepsi" }, { k: "devam", l: "Devam eden" }, { k: "tamam", l: "Tamamlanan" },
  ];
  return (
    <Layout>
      <section className="sayfa-basi">
        <div className="veri bel">Projeler</div>
        <h1 className="h-dev bel" style={{ margin: "14px 0 30px" }}>Başladığımızı bitiriyoruz</h1>
        <div className="adimlar" style={{ marginBottom: 40 }}>
          {sekmeler.map((s) => (
            <button key={s.k} className={`adim ${sekme === s.k ? "aktif" : ""}`} onClick={() => setSekme(s.k)} data-testid={`sekme-${s.k}`}>{s.l}</button>
          ))}
        </div>
        {filtreli.length === 0 ? (
          <p className="veri">Bu kategoride proje bulunmuyor.</p>
        ) : (
          <div className="proje-izgara">
            {filtreli.map((p) => (
              <Link to={`/proje/${p.slug}`} className="proje bel" key={p.id} data-testid={`proje-karti-${p.slug}`}>
                <div className="kutu">
                  <span className={`rozet ${p.status === "devam-eden" ? "aktif" : ""}`}>
                    {p.status === "devam-eden" ? "Devam ediyor" : p.status === "yakinda" ? "Yakında" : "Tamamlandı"}
                  </span>
                  <img src={asset(p.hero_gunduz)} alt={p.name} />
                </div>
                <h3>{p.name}</h3>
                <div className="veri">{(p.summary || "").split("·").slice(0, 3).map((s) => s.trim()).join(" · ")}</div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
